export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc',
}


export enum SessionItems {
    complaintlist_pageSize = 'complaintlist_pageSize',
    complaintlist_sortOrder = 'complaintlist_sortOrder',
    complaintlist_sortBy = 'complaintlist_sortBy',
    complaintlist_fitlerForm = 'complaintlist_fitlerForm',
    complaintSideNav = 'complaintSideNav',
    complaintTableView = 'complaintTableView',


    risk_matrix_fitlerForm = 'risk_matrix_fitlerForm',
    risk_matrix_pageSize = 'risk_matrix_pageSize',
    risk_matrix_sortOrder = 'risk_matrix_sortOrder',
    risk_matrix_sortBy = 'risk_matrix_sortBy',
    risk_matrixSideNav = 'risk_matrixSideNav',


    alertlist_pageSize = 'alertlist_pageSize',
    alertlist_sortOrder = 'alertlist_sortOrder',
    alertlist_sortBy = 'alertlist_sortBy',
    alertlist_fitlerForm = 'alertlist_fitlerForm',
    alertSideNav = 'alertSideNav',
    alertTableView = 'alertTableView',
    alertDynamicFilterSideNav = "alertDynamicFilterSideNav",
    alertlist_dynamicFilters = "alertlist_dynamicFilters",
    alertlist_dynamicFiltersApplied = "alertlist_dynamicFiltersApplied",
    alertlist_dynamicFilterModuleSelected = "alertlist_dynamicFilterModuleSelected",
    alertlist_dynamicFilterWorkflowSelected = "alertlist_dynamicFilterWorkflowSelected",
    alertlist_dynamicFilterStepSelected = "alertlist_dynamicFilterStepSelected",
    alertlist_advancedFiltersApplied = "alertlist_advancedFiltersApplied",

    boardlist_pageSize = 'boardlist_pageSize',
    boardlist_sortOrder = 'boardlist_sortOrder',
    boardlist_sortBy = 'boardlist_sortBy',
    boardlist_fitlerForm = 'boardlist_fitlerForm',
    boardSideNav = 'boardSideNav',
    boardTableView = 'boardTableView',
    boards_nav = 'boards_nav',

    caselist_pageSize = 'caselist_pageSize',
    caselist_sortOrder = 'caselist_sortOrder',
    caselist_sortBy = 'caselist_sortBy',
    caselist_fitlerForm = 'caselist_fitlerForm',
    caseSideNav = 'caseSideNav',
    caseTableView = 'caseTableView',
    caseDynamicFilterSideNav = "caseDynamicFilterSideNav",
    caselist_dynamicFilters = "caselist_dynamicFilters",
    caselist_dynamicFiltersApplied = "caselist_dynamicFiltersApplied",
    caselist_dynamicFilterModuleSelected = "caselist_dynamicFilterModuleSelected",
    caselist_dynamicFilterWorkflowSelected = "caselist_dynamicFilterWorkflowSelected",
    caselist_dynamicFilterStepSelected = "caselist_dynamicFilterStepSelected",
    caseReportDynamicFilterSideNav = "caseReportDynamicFilterSideNav",
    caseReportDynamicFilterWorkflowSelected = "caseReportDynamicFilterWorkflowSelected",
    caseReportDynamicFilterStepSelected = "caseReportDynamicFilterStepSelected",
    caseReportDynamicFilters = "caseReportDynamicFilters",
    caseReportDynamicFiltersApplied = "caseReportDynamicFiltersApplied",
    caselist_advancedFiltersApplied = "caselist_advancedFiltersApplied",

    alertReport_pageSize = 'alertreport_pageSize',
    alertReport_sortOrder = 'alertreport_sortOrder',
    alertReport_sortBy = 'alertreport_sortBy',
    alertReport_fitlerForm = 'alertreport_fitlerForm',
    alertReportTableView = 'alertReportTableView',
    alertReportDynamicFilterSideNav = 'alertReportDynamicFilterSideNav',
    alertReportDynamicFilterWorkflowSelected = 'alertReportDynamicFilterWorkflowSelected',
    alertReportDynamicFilterStepSelected = 'alertReportDynamicFilterStepSelected',
    alertReportDynamicFilters = 'alertReportDynamicFilters',
    alertReportDynamicFiltersApplied = 'alertReportDynamicFiltersApplied',
    alertReport_filterComplaintForm = 'alertReport_filterComplaintForm',
    alertReport_filterComplaintApplied = 'alertReport_filterComplaintApplied',

    //
    proceedingReport_pageSize = 'proceedingreport_pageSize',
    proceedingReport_sortOrder = 'proceedingreport_sortOrder',
    proceedingReport_sortBy = 'proceedingreport_sortBy',
    proceedingReport_fitlerForm = 'proceedingreport_fitlerForm',
    proceedingReportTableView = 'proceedingReportTableView',
    proceedingsReportDynamicFilterSideNav = 'proceedingsReportDynamicFilterSideNav',
    proceedingReportDynamicFilters = 'proceedingReportDynamicFilters',
    proceedingReportDynamicFiltersApplied = 'proceedingReportDynamicFiltersApplied',
    proceedingReportDynamicFilterWorkflowSelected = 'proceedingReportDynamicFilterWorkflowSelected',
    proceedingReportDynamicFilterStepSelected = 'proceedingReportDynamicFilterStepSelected',         

    casereport_pageSize = 'casereport_pageSize',
    casereport_sortOrder = 'casereport_sortOrder',
    casereport_sortBy = 'casereport_sortBy',
    casereport_fitlerForm = 'casereport_fitlerForm',
    caseReportSideNav = 'caseReportSideNav',
    caseReportTableView = 'caseReportTableView',
    caseReport_filterAlertForm = 'caseReport_filterAlertForm',
    caseReport_filterAlertApplied = 'caseReport_filterAlertApplied',

    complaintReport_pageSize = 'complaintReport_pageSize',
    complaintReport_sortOrder = 'complaintReport_sortOrder',
    complaintReport_sortBy = 'complaintReport_sortBy',
    complaintReport_fitlerForm = 'complaintReport_fitlerForm',
    complaintReportSideNav = 'complaintReportSideNav',
    complaintReportTableView = 'complaintReportTableView',
    complaintReportDynamicFilters = 'complaintReportDynamicFilters',
    complaintReportDynamicFiltersApplied = 'complaintReportDynamicFiltersApplied',
    complaintReportDynamicFilterWorkflowSelected = 'complaintReportDynamicFilterWorkflowSelected',
    complaintReportDynamicFilterStepSelected = 'complaintReportDynamicFilterStepSelected',
    complaintReportDynamicFilterSideNav = 'complaintReportDynamicFilterSideNav',
    ppFileDirectoryCurrentParentFolderId = "ppFileDirectoryCurrentParentFolderId",
    ppFileDirectory_pageSize = 'ppFileDirectory_pageSize',
    ppFileDirectory_sortOrder = 'ppFileDirectory_sortOrder',
    ppFileDirectory_sortBy = 'ppFileDirectory_sortBy',
    ppFileDirectory_fitlerForm = 'ppFileDirectory_fitlerForm',
    ppFileDirectorySideNav = 'ppFileDirectorySideNav',
    ppFileDirectoryFileDetailSideNav = 'ppFileDirectoryFileDetailSideNav',
    ppFileDirectoryTableView = 'ppFileDirectoryTableView',
    ppFileDirectoryRootFolderId = 'ppFileDirectoryRootFolderId',
    ppFileDirectoryCurrentFolderId = 'ppFileDirectoryCurrentFolderId',
    ppFileDirectoryCurrentLocationString = 'ppFileDirectoryCurrentLocationString',
    ppFileDirectoryApprover_fitlerForm = 'ppFileDirectoryApprover_fitlerForm', 
    ppFileDirectoryApprover_pageSize = 'ppFileDirectoryApprover_pageSize',
    ppFileDirectoryApprover_sortOrder = 'ppFileDirectoryApprover_sortOrder',
    ppFileDirectoryApprover_sortBy = 'ppFileDirectoryApprover_sortBy',

    //pp-visualization
    ppVisualization_pageSize = 'ppVisualization_pageSize',
    ppVisualization_pageIndex = 'ppVisualization_pageIndex',
    ppVisualization_sortOrder = 'ppVisualization_sortOrder',
    ppVisualization_sortBy = 'ppVisualization_sortBy',
    ppVisualizationFilterSideNav = 'ppVisualization_filterSideNav',
    ppApprover_pageIndex = "ppApprover_pageIndex",
    ppApprover_pageSize = "ppApprover_pageSize",

    //Security - Roles
    roles_pageSize = 'roles_pageSize',
    roles_pageIndex = 'roles_pageIndex',
    roles_sortOrder = 'roles_sortOrder',
    roles_sortBy = 'roles_sortBy',
    rolesSideNav = 'rolesSideNav',
    rolesTableView = 'rolesTableView',
    rolesFilterSideNav = 'rolesFilterSideNav',

    //Security - Users
    users_pageSize = 'users_pageSize',
    users_pageIndex = 'users_pageIndex',
    users_sortOrder = 'users_sortOrder',
    users_sortBy = 'users_sortBy',
    usersSideNav = 'usersSideNav',
    usersTableView = 'usersTableView',
    usersFilterSideNav = 'usersFilterSideNav',

    //Security - UsersGroups
    usersGroups_pageSize = 'usersGroups_pageSize',
    usersGroups_pageIndex = 'usersGroups_pageIndex',
    usersGroups_sortOrder = 'usersGroups_sortOrder',
    usersGroups_sortBy = 'usersGroups_sortBy',
    usersGroupsSideNav = 'usersGroupsSideNav',
    usersGroupsTableView = 'usersGroupsTableView',
    usersGroupsFilterSideNav = 'usersGroupsFilterSideNav',

    // Tenants
    tenants_pageSize = 'tenants_pageSize',
    tenants_pageIndex = 'tenants_pageIndex',
    tenants_sortOrder = 'tenants_sortOrder',
    tenants_sortBy = 'tenants_sortBy',
    tenantsSideNav = 'tenantsSideNav',
    tenantsTableView = 'tenantsTableView',
    tenantsFilterSideNav = 'tenantsFilterSideNav',

    // Approvals

    approvalsTableView = 'approvalsTableView',
    approvalsFilterSideNav = 'approvalsFilterSideNav',

    tenant_approvals_pageSize = 'tenant_approvals_pageSize',
    tenant_approvals_pageIndex = 'tenant_approvals_pageIndex',
    tenant_approvals_sortOrder = 'tenant_approvals_sortOrder',
    tenant_approvals_sortBy = 'tenant_approvals_sortBy',
    

    permission_approvals_pageSize = 'permission_approvals_pageSize',
    permission_approvals_pageIndex = 'permission_approvals_pageIndex',
    permission_approvals_sortOrder = 'permission_approvals_sortOrder',
    permission_approvals_sortBy = 'permission_approvals_sortBy',

    user_approvals_pageSize = 'user_approvals_pageSize',
    user_approvals_pageIndex = 'user_approvals_pageIndex',
    user_approvals_sortOrder = 'user_approvals_sortOrder',
    user_approvals_sortBy = 'user_approvals_sortBy',

    // Audit - Security

    auditTableView = 'auditTableView',
    auditFilterSideNav = 'auditFilterSideNav',

    tenant_audit_pageSize = 'tenant_audit_pageSize',
    tenant_audit_pageIndex = 'tenant_audit_pageIndex',
    tenant_audit_sortOrder = 'tenant_audit_sortOrder',
    tenant_audit_sortBy = 'tenant_audit_sortBy',
    

    usergroup_audit_pageSize = 'usergroup_audit_pageSize',
    usergroup_audit_pageIndex = 'usergroup_audit_pageIndex',
    usergroup_audit_sortOrder = 'usergroup_audit_sortOrder',
    usergroup_audit_sortBy = 'usergroup_audit_sortBy',

    user_audit_pageSize = 'user_audit_pageSize',
    user_audit_pageIndex = 'user_audit_pageIndex',
    user_audit_sortOrder = 'user_audit_sortOrder',
    user_audit_sortBy = 'user_audit_sortBy',

    //Complaints Portal - Faqs
    faqs_pageSize = 'faqs_pageSize',
    faqs_pageIndex = 'faqs_pageIndex',
    faqs_sortOrder = 'faqs_sortOrder',
    faqs_sortBy = 'faqs_sortBy',
    faqsSideNav = 'faqsSideNav',
    faqsTableView = 'faqsTableView',
    faqsFilterSideNav = 'faqsFilterSideNav',

    contentResources_pageSize = 'contentResources_pageSize',
    contentResources_pageIndex = 'contentResources_pageIndex',
    contentResources_sortOrder = 'contentResources_sortOrder',
    contentResources_sortBy = 'contentResources_sortBy',
    contentResourcesSideNav = 'contentResourcesSideNav',
    contentResourcesTableView = 'contentResourcesTableView',
    contentResourcesFilterSideNav = 'contentResourcesFilterSideNav',

    criticality_pageSize = 'criticality_pageSize',
    criticality_pageIndex = 'criticality_pageIndex',
    criticality_sortOrder = 'criticality_sortOrder',
    criticality_sortBy = 'criticality_sortBy',
    criticalitySideNav = 'criticalitySideNav',
    criticalityTableView = 'criticalityTableView',
    criticalityFilterSideNav = 'criticalityFilterSideNav',

    rejectedReason_pageSize = 'rejectedReason_pageSize',
    rejectedReason_pageIndex = 'rejectedReason_pageIndex',
    rejectedReason_sortOrder = 'rejectedReason_sortOrder',
    rejectedReason_sortBy = 'rejectedReason_sortBy',
    rejectedReasonSideNav = 'rejectedReasonSideNav',
    rejectedReasonTableView = 'rejectedReasonTableView',
    rejectedReasonFilterSideNav = 'rejectedReasonFilterSideNav',

    typeComplaints_pageSize = 'typeComplaints_pageSize',
    typeComplaints_pageIndex = 'typeComplaints_pageIndex',
    typeComplaints_sortOrder = 'typeComplaints_sortOrder',
    typeComplaints_sortBy = 'typeComplaints_sortBy',
    typeComplaintsSideNav = 'typeComplaintsSideNav',
    typeComplaintsTableView = 'typeComplaintsTableView',
    typeComplaintsFilterSideNav = 'typeComplaintsFilterSideNav',

    alertDueDate_pageSize = 'alertDueDate_pageSize',
    alertDueDate_pageIndex = 'alertDueDate_pageIndex',
    alertDueDate_sortOrder = 'alertDueDate_sortOrder',
    alertDueDate_sortBy = 'alertDueDate_sortBy',
    alertDueDateSideNav = 'alertDueDateSideNav',
    alertDueDateTableView = 'alertDueDateTableView',
    alertDueDateFilterSideNav = 'alertDueDateFilterSideNav',

    // Audit - Complaints

    auditComplaintsTableView = 'auditComplaintsTableView',
    auditComplaintsFilterSideNav = 'auditComplaintsFilterSideNav',

    faqs_audit_pageSize = 'faqs_audit_pageSize',
    faqs_audit_pageIndex = 'faqs_audit_pageIndex',
    faqs_audit_sortOrder = 'faqs_audit_sortOrder',
    faqs_audit_sortBy = 'faqs_audit_sortBy',
    

    content_audit_pageSize = 'content_audit_pageSize',
    content_audit_pageIndex = 'content_audit_pageIndex',
    content_audit_sortOrder = 'content_audit_sortOrder',
    content_audit_sortBy = 'content_audit_sortBy',

    config_audit_pageSize = 'config_audit_pageSize',
    config_audit_pageIndex = 'config_audit_pageIndex',
    config_audit_sortOrder = 'config_audit_sortOrder',
    config_audit_sortBy = 'config_audit_sortBy',

    classification_audit_pageSize = 'classification_audit_pageSize',
    classification_audit_pageIndex = 'classification_audit_pageIndex',
    classification_audit_sortOrder = 'classification_audit_sortOrder',
    classification_audit_sortBy = 'classification_audit_sortBy',

    typeComplaints_audit_pageSize = 'typeComplaints_audit_pageSize',
    typeComplaints_audit_pageIndex = 'typeComplaints_audit_pageIndex',
    typeComplaints_audit_sortOrder = 'typeComplaints_audit_sortOrder',
    typeComplaints_audit_sortBy = 'typeComplaints_audit_sortBy',

    //Forms - Complaints

    formsManagement_pageSize = 'formsManagement_pageSize',
    formsManagement_pageIndex = 'formsManagement_pageIndex',
    formsManagement_sortOrder = 'formsManagement_sortOrder',
    formsManagement_sortBy = 'formsManagement_sortBy',    
    formsManagementSideNav = 'formsManagementSideNav',
    formsManagementTableView = 'formsManagementTableView',
    formsManagementFilterSideNav = 'formsManagementFilterSideNav',

    followupActions_pageSize = 'followupActions_pageSize',
    followupActions_pageIndex = 'followupActions_pageIndex',
    followupActions_sortOrder = 'followupActions_sortOrder',
    followupActions_sortBy = 'followupActions_sortBy',
    followupActionsSideNav = 'followupActionsSideNav',
    followupActionsTableView = 'followupActionsTableView',
    followupActionsFilterSideNav = 'followupActionsFilterSideNav',

    controllist_sortOrder = 'controllist_sortOrder',
  controllist_sortBy = 'controllist_sortBy',
  controllist_fitlerForm = 'controllist_fitlerForm',
  controlSideNav = 'controlSideNav',
  controlTableView = 'controlTableView',
  controllist_pageSize = 'controllist_pageSize',

  parameterizationlist_sortOrder = 'parameterizationlist_sortOrder',
  parameterizationlist_sortBy = 'parameterizationlist_sortBy',
  parameterizationlist_fitlerForm = 'parameterizationlist_fitlerForm',
  parameterizationSideNav = 'parameterizationSideNav',
  parameterizationTableView = 'parameterizationTableView',
  parameterizationlist_pageSize = 'parameterizationlist_pageSize',

  parameterizationoposicionlist_sortOrder = 'parameterizationoposicionlist_sortOrder',
  parameterizationoposicionlist_sortBy = 'parameterizationoposicionlist_sortBy',
  parameterizationoposicionlist_fitlerForm = 'parameterizationoposicionlist_fitlerForm',
  parameterizationoposicionSideNav = 'parameterizationoposicionSideNav',
  parameterizationoposicionTableView = 'parameterizationoposicionTableView',
  parameterizationoposicionlist_pageSize = 'parameterizationoposicionlist_pageSize',

  parameterizationmanuallist_sortOrder = 'parameterizationmanuallist_sortOrder',
  parameterizationmanuallist_sortBy = 'parameterizationmanuallist_sortBy',
  parameterizationmanuallist_fitlerForm = 'parameterizationmanuallist_fitlerForm',
  parameterizationmanualSideNav = 'parameterizationmanualSideNav',
  parameterizationmanualTableView = 'parameterizationmanualTableView',
  parameterizationmanuallist_pageSize = 'parameterizationmanuallist_pageSize',

  arameterizationruleslist_sortOrder = 'parameterizationruleslist_sortOrder',
  parameterizationruleslist_sortBy = 'parameterizationruleslist_sortBy',
  parameterizationruleslist_fitlerForm = 'parameterizationruleslist_fitlerForm',
  parameterizationrulesSideNav = 'parameterizationrulesSideNav',
  parameterizationrulesTableView = 'parameterizationrulesTableView',
  parameterizationruleslist_pageSize = 'parameterizationruleslist_pageSize',

  //Masters

  AssociatedProcesseslist_pageSize = 'AssociatedProcesseslist_pageSize',
  AssociatedProcesseslist_sortOrder = 'AssociatedProcesseslist_sortOrder',
  AssociatedProcesseslist_sortBy = 'AssociatedProcesseslist_sortBy',
  AssociatedProcesseslist_fitlerForm = 'AssociatedProcesseslist_fitlerForm',
  AssociatedProcessesSideNav = 'AssociatedProcessesSideNav',
  AssociatedProcessesTableView = 'AssociatedProcessesTableView',
  AssociatedProcesses_nav = 'AssociatedProcesses_nav',

  Responsiblelist_pageSize = 'Responsiblelist_pageSize',
  Responsiblelist_sortOrder = 'Responsiblelist_sortOrder',
  Responsiblelist_sortBy = 'Responsiblelist_sortBy',
  Responsiblelist_fitlerForm = 'Responsiblelist_fitlerForm',
  ResponsibleSideNav = 'ResponsibleSideNav',
  ResponsibleTableView = 'ResponsibleTableView',
  Responsible_nav = 'Responsible_nav',

  Risklist_pageSize = 'Risklist_pageSize',
  Risklist_sortOrder = 'Risklist_sortOrder',
  Risklist_sortBy = 'Risklist_sortBy',
  Risklist_fitlerForm = 'Risklist_fitlerForm',
  RiskSideNav = 'RiskSideNav',
  RiskTableView = 'RiskTableView',
  Risk_nav = 'Risk_nav',

  Periodicitylist_pageSize = 'Periodicitylist_pageSize',
  Periodicitylist_sortOrder = 'Periodicitylist_sortOrder',
  Periodicitylist_sortBy = 'Periodicitylist_sortBy',
  Periodicitylist_fitlerForm = 'Periodicitylist_fitlerForm',
  PeriodicitySideNav = 'PeriodicitySideNav',
  PeriodicityTableView = 'PeriodicityTableView',
  Periodicity_nav = 'Periodicity_nav',

  ControlTypelist_pageSize = 'ControlTypelist_pageSize',
  ControlTypelist_sortOrder = 'ControlTypelist_sortOrder',
  ControlTypelist_sortBy = 'ControlTypelist_sortBy',
  ControlTypelist_fitlerForm = 'ControlTypelist_fitlerForm',
  ControlTypeSideNav = 'ControlTypeSideNav',
  ControlTypeTableView = 'ControlTypeTableView',
  ControlType_nav = 'ControlType_nav',
}

